<template>
  <div>
    <collapse class="associate-orders" :active-index="0">
      <collapse-item :body-classes="'p-0'" :hide-caret="true">
        <h3 slot="header" class="mb-0">Asociar Pedido</h3>

        <collapse v-if="orders.length" class="orders-items" :active-index="0">
          <collapse-item v-for="order in orders" :key="order.id" class="mb-0">
            <div slot="title">
              <router-link v-if="$can('show', 'orders')" :to="{ name: 'OrderShow', params: { id: order.id } }">
                Pedido {{ order.code }} - {{ order.producer.businessName }} - {{ order.campaign.name }} -
                {{ projection.variety.crop.name }} -
                {{ order.state.label }}
              </router-link>
              <button class="btn base-button btn-primary btn-sm mx-3" @click="addOrder(order)">Añadir</button>
            </div>

            <order-items-list :add="false" :edit="false" :order-id="order.id" :items="order.items" />
          </collapse-item>
        </collapse>

        <div v-else class="p-3">
          <p>No tine pedidos para asociar a esta proyección</p>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';
import OrderItemsList from '../../Orders/List/OrderItemsList';

export default {
  components: {
    Collapse,
    CollapseItem,
    OrderItemsList,
  },

  props: {
    orders: {
      type: Array,
      required: false,
    },

    projection: {
      type: Object,
      required: false,
    },
  },

  methods: {
    addOrder(order) {
      const edited = { ...order };
      edited.projectionId = this.projection.id;
      this.$emit('addOrder', edited);
    },
  },
};
</script>

<style lang="scss" scoped>
.associate-orders > .card {
  background-color: transparent;
  box-shadow: 0 0 0;
}

::v-deep .accordion .card-header.not-collapse {
  padding: 1.8rem 1.5rem;
  border-radius: calc(0.375rem - 1px);
}

.orders-items .card {
  margin-top: 1rem;
  box-shadow: 0 0 2rem 0 #8898aa00;
}
</style>
